import { EditorPresetBuilder } from '@atlaskit/editor-common/preset';
import { accessibilityUtilsPlugin } from '@atlaskit/editor-plugin-accessibility-utils';
import { analyticsPlugin } from '@atlaskit/editor-plugin-analytics';
import { annotationPlugin } from '@atlaskit/editor-plugin-annotation';
import { avatarGroupPlugin } from '@atlaskit/editor-plugin-avatar-group';
import { basePlugin } from '@atlaskit/editor-plugin-base';
import { batchAttributeUpdatesPlugin } from '@atlaskit/editor-plugin-batch-attribute-updates';
import { betterTypeHistoryPlugin } from '@atlaskit/editor-plugin-better-type-history';
import { blockMenuPlugin } from '@atlaskit/editor-plugin-block-menu';
import { blockTypePlugin } from '@atlaskit/editor-plugin-block-type';
import { breakoutPlugin } from '@atlaskit/editor-plugin-breakout';
import { cardPlugin } from '@atlaskit/editor-plugin-card';
import { clearMarksOnEmptyDocPlugin } from '@atlaskit/editor-plugin-clear-marks-on-empty-doc';
import { clipboardPlugin } from '@atlaskit/editor-plugin-clipboard';
import { codeBidiWarningPlugin } from '@atlaskit/editor-plugin-code-bidi-warning';
import { codeBlockPlugin } from '@atlaskit/editor-plugin-code-block';
import { collabEditPlugin } from '@atlaskit/editor-plugin-collab-edit';
import { compositionPlugin } from '@atlaskit/editor-plugin-composition';
import { connectivityPlugin } from '@atlaskit/editor-plugin-connectivity';
import { contentFormatPlugin } from '@atlaskit/editor-plugin-content-format';
import { contentInsertionPlugin } from '@atlaskit/editor-plugin-content-insertion';
import { contextPanelPlugin } from '@atlaskit/editor-plugin-context-panel';
import { copyButtonPlugin } from '@atlaskit/editor-plugin-copy-button';
import { dataConsumerPlugin } from '@atlaskit/editor-plugin-data-consumer';
import { decorationsPlugin } from '@atlaskit/editor-plugin-decorations';
import { editorDisabledPlugin } from '@atlaskit/editor-plugin-editor-disabled';
import { editorViewModePlugin } from '@atlaskit/editor-plugin-editor-viewmode';
import { editorViewModeEffectsPlugin } from '@atlaskit/editor-plugin-editor-viewmode-effects';
import { engagementPlatformPlugin } from '@atlaskit/editor-plugin-engagement-platform';
import { extensionPlugin } from '@atlaskit/editor-plugin-extension';
import { featureFlagsPlugin } from '@atlaskit/editor-plugin-feature-flags';
import { floatingToolbarPlugin } from '@atlaskit/editor-plugin-floating-toolbar';
import { focusPlugin } from '@atlaskit/editor-plugin-focus';
import { fragmentPlugin } from '@atlaskit/editor-plugin-fragment';
import { gridPlugin } from '@atlaskit/editor-plugin-grid';
import { helpDialogPlugin } from '@atlaskit/editor-plugin-help-dialog';
import { historyPlugin } from '@atlaskit/editor-plugin-history';
import { hyperlinkPlugin } from '@atlaskit/editor-plugin-hyperlink';
import { insertBlockPlugin } from '@atlaskit/editor-plugin-insert-block';
import { interactionPlugin } from '@atlaskit/editor-plugin-interaction';
import { limitedModePlugin } from '@atlaskit/editor-plugin-limited-mode';
import { listPlugin } from '@atlaskit/editor-plugin-list';
import { localIdPlugin } from '@atlaskit/editor-plugin-local-id';
import { mediaPlugin } from '@atlaskit/editor-plugin-media';
import { mediaInsertPlugin } from '@atlaskit/editor-plugin-media-insert';
import { metricsPlugin } from '@atlaskit/editor-plugin-metrics';
import { pastePlugin } from '@atlaskit/editor-plugin-paste';
import { placeholderPlugin } from '@atlaskit/editor-plugin-placeholder';
import { primaryToolbarPlugin } from '@atlaskit/editor-plugin-primary-toolbar';
import { quickInsertPlugin } from '@atlaskit/editor-plugin-quick-insert';
import { rulePlugin } from '@atlaskit/editor-plugin-rule';
import { scrollIntoViewPlugin } from '@atlaskit/editor-plugin-scroll-into-view';
import { selectionPlugin } from '@atlaskit/editor-plugin-selection';
import { selectionExtensionPlugin } from '@atlaskit/editor-plugin-selection-extension';
import { selectionMarkerPlugin } from '@atlaskit/editor-plugin-selection-marker';
import { selectionToolbarPlugin } from '@atlaskit/editor-plugin-selection-toolbar';
import { showDiffPlugin } from '@atlaskit/editor-plugin-show-diff';
import { submitEditorPlugin } from '@atlaskit/editor-plugin-submit-editor';
import { tablePlugin } from '@atlaskit/editor-plugin-table';
import { tasksAndDecisionsPlugin } from '@atlaskit/editor-plugin-tasks-and-decisions';
import { textFormattingPlugin } from '@atlaskit/editor-plugin-text-formatting';
import { toolbarPlugin } from '@atlaskit/editor-plugin-toolbar';
import { toolbarListsIndentationPlugin } from '@atlaskit/editor-plugin-toolbar-lists-indentation';
import { typeAheadPlugin } from '@atlaskit/editor-plugin-type-ahead';
import { ufoPlugin } from '@atlaskit/editor-plugin-ufo';
import { undoRedoPlugin } from '@atlaskit/editor-plugin-undo-redo';
import { unsupportedContentPlugin } from '@atlaskit/editor-plugin-unsupported-content';
import { userIntentPlugin } from '@atlaskit/editor-plugin-user-intent';
import { userPreferencesPlugin } from '@atlaskit/editor-plugin-user-preferences';
import { widthPlugin } from '@atlaskit/editor-plugin-width';
import { aiSpeechToTextPlugin } from '@atlassian/ai-audio/editor-plugin';
import { aiPlugin } from '@atlassian/editor-plugin-ai';
import { aiDefinitionsPlugin } from '@atlassian/editor-plugin-ai-definitions';
import { aiImageGenerationPlugin } from '@atlassian/editor-plugin-ai-image-generation';
import { aiStreamingOrchestratorPlugin } from '@atlassian/editor-plugin-ai-streaming-orchestrator';
import { aiSuggestionsPlugin } from '@atlassian/editor-plugin-ai-suggestions';
import { markdownModePlugin } from '@atlassian/editor-plugin-markdown-mode';
import { isMarkdownCompatibleQuickInsertItem } from '@atlassian/editor-plugin-markdown-mode/markdown-compatible-quick-insert-items';
import { referentialityPlugin } from '@atlassian/editor-referentiality';

import { aiDefinitionsPluginOptions } from '../full-page/pluginOptions/aiDefinitionsPluginOptions';
import { aiImageGenerationPluginOptions } from '../full-page/pluginOptions/aiImageGenerationPluginOptions';
import { aiPluginOptions } from '../full-page/pluginOptions/aiPluginOptions';
import { aiStreamingOrchestratorPluginOptions } from '../full-page/pluginOptions/aiStreamingOrchestratorPluginOptions';
import { aiSuggestionsOptions } from '../full-page/pluginOptions/aiSuggestionsOptions';
import { analyticsPluginOptions } from '../full-page/pluginOptions/analyticsPluginOptions';
import { annotationPluginOptions } from '../full-page/pluginOptions/annotationPluginOptions';
import { avatarGroupPluginOptions } from '../full-page/pluginOptions/avatarGroupPluginOptions';
import { basePluginOptions } from '../full-page/pluginOptions/basePluginOptions';
import { blockTypePluginOptions } from '../full-page/pluginOptions/blockTypePluginOptions';
import { breakoutPluginOptions } from '../full-page/pluginOptions/breakoutPluginOptions';
import { cardPluginOptions } from '../full-page/pluginOptions/cardPluginOptions';
import { codeBidiWarningPluginOptions } from '../full-page/pluginOptions/codeBidiWarningPluginOptions';
import { codeBlockPluginOptions } from '../full-page/pluginOptions/codeBlockPluginOptions';
import { collabEditPluginOptions } from '../full-page/pluginOptions/collabEditPluginOptions';
import { contentFormatPluginOptions } from '../full-page/pluginOptions/contentFormatPluginOptions';
import { contextPanelPluginOptions } from '../full-page/pluginOptions/contextPanelPluginOptions';
import { editorDisabledPluginOptions } from '../full-page/pluginOptions/editorDisabledPluginOptions';
import { editorViewModePluginOptions } from '../full-page/pluginOptions/editorViewModePluginOptions';
import { engagementPlatformPluginOptions } from '../full-page/pluginOptions/engagementPlatformPluginOptions';
import { extensionPluginOptions } from '../full-page/pluginOptions/extensionPluginOptions';
import { featureFlagsPluginOptions } from '../full-page/pluginOptions/featureFlagsPluginOptions';
import { helpDialogPluginOptions } from '../full-page/pluginOptions/helpDialogPluginOptions';
import { hyperlinkPluginOptions } from '../full-page/pluginOptions/hyperlinkPluginOptions';
import { insertBlockPluginOptions } from '../full-page/pluginOptions/insertBlockPluginOptions';
import { limitedModePluginOptions } from '../full-page/pluginOptions/limitedModePluginOptions';
import { mediaPluginOptions } from '../full-page/pluginOptions/mediaPluginOptions/mediaPluginOptions';
import { metricsPluginOptions } from '../full-page/pluginOptions/metricsPluginOptions';
import { pastePluginOptions } from '../full-page/pluginOptions/pastePluginOptions';
import { placeholderPluginOptions } from '../full-page/pluginOptions/placeholderPluginOptions/placeholderPluginOptions';
import { primaryToolbarPluginOptions } from '../full-page/pluginOptions/primaryToolbarPluginOptions';
import { quickInsertPluginOptions } from '../full-page/pluginOptions/quickInsertPluginOptions';
import { referentialityPluginOptions } from '../full-page/pluginOptions/referentialityPluginOptions';
import { selectionExtensionPluginOptions } from '../full-page/pluginOptions/selectionExtensionPluginOptions';
import { selectionMarkerPluginOptions } from '../full-page/pluginOptions/selectionMarkerPluginOptions';
import { selectionPluginOptions } from '../full-page/pluginOptions/selectionPluginOptions';
import { selectionToolbarPluginOptions } from '../full-page/pluginOptions/selectionToolbarPluginOptions';
import { showDiffPluginOptions } from '../full-page/pluginOptions/showDiffPluginOptions';
import { submitEditorPluginOptions } from '../full-page/pluginOptions/submitEditorPluginOptions';
import { tablePluginOptions } from '../full-page/pluginOptions/tablePluginOptions';
import { tasksAndDecisionsPluginOptions } from '../full-page/pluginOptions/tasksAndDecisionsPluginOptions';
import { textFormattingPluginOptions } from '../full-page/pluginOptions/textFormattingPluginOptions';
import { toolbarPluginOptions } from '../full-page/pluginOptions/toolbarPluginOptions';
import { typeAheadPluginOptions } from '../full-page/pluginOptions/typeAheadPluginOptions';
import { userPreferencesPluginOptions } from '../full-page/pluginOptions/userPreferencesPluginOptions';
import type { AllPluginOptions } from '../full-page/types';

import type {
	MarkdownCompatiblePresetBuilder,
	MarkdownCompatiblePresetProps,
	MarkdownPresetBuilder,
	MarkdownPresetProps,
} from './types';

/**
 * Confluence's GFM-safe WYSIWYG editor preset.
 *
 * The preset is an explicit allowlist: every plugin that runs in markdown
 * mode is added here by name. Plugins not on this list — including any new
 * plugins added to `fullPagePreset` — are deliberately *not* in markdown
 * mode and require an explicit decision (and a corresponding addition to
 * this file) to opt in.
 *
 * Plugins that have been considered and intentionally excluded — and the
 * reason — are listed in the `// excluded:` block at the bottom. Some are
 * tagged with `revisit:` and may move into the allowlist as their markdown
 * support stabilises.
 *
 * The shape of the chain mirrors `fullPagePreset` (same factory helpers,
 * same provider plumbing, same option shapes) so that consumers can extend
 * either preset with the same `.add(...)` / `.maybeAdd(...)` patterns.
 *
 * The schema is a strict subset of `fullPagePreset`'s schema. Runtime
 * mode toggles rebuild the schema from the active preset — see
 * `ReactEditorView.reconfigureState` (under `cc-markdown-mode`).
 *
 * This preset intentionally omits the Markdown source view. Use it when the
 * product stores or exchanges GFM Markdown but should present a normal
 * WYSIWYG editor. Pair it with `createGfmMarkdownTransformer` to load and
 * retrieve Markdown through the editor core transformer APIs.
 */
export function markdownCompatiblePreset(
	props: MarkdownCompatiblePresetProps,
): MarkdownCompatiblePresetBuilder {
	const { intl, providers, enabledOptionalPlugins } = props;
	// We remove all `never` properties from the FullPagePresetProps.pluginOptions,
	// we need to return them back.
	const pluginOptions = props.pluginOptions as AllPluginOptions;

	return (
		new EditorPresetBuilder()
			// ── Foundational / lifecycle ────────────────────────────────────
			.maybeAdd(
				[limitedModePlugin, limitedModePluginOptions({ options: pluginOptions.limitedMode })],
				!pluginOptions.limitedMode.killSwitchEnabled,
			)
			.add([featureFlagsPlugin, featureFlagsPluginOptions({ options: pluginOptions.featureFlags })])
			.add([analyticsPlugin, analyticsPluginOptions({ options: pluginOptions.analytics })])
			.add(betterTypeHistoryPlugin)
			.add([pastePlugin, pastePluginOptions({ options: pluginOptions.paste, providers })])
			.add(clipboardPlugin)
			.add(focusPlugin)
			.add(compositionPlugin)
			.add([basePlugin, basePluginOptions({ options: pluginOptions.base })])
			.maybeAdd(
				[
					userPreferencesPlugin,
					userPreferencesPluginOptions({ providers, options: pluginOptions.userPreferencesPlugin }),
				],
				enabledOptionalPlugins.userPreferences,
			)
			.add(decorationsPlugin)
			.add([typeAheadPlugin, typeAheadPluginOptions({ options: pluginOptions.typeAhead })])
			.add(historyPlugin)

			// ── Toolbar / chrome ────────────────────────────────────────────
			.add([
				primaryToolbarPlugin,
				primaryToolbarPluginOptions({ options: pluginOptions.primaryToolbar }),
			])
			.maybeAdd(
				[toolbarPlugin, toolbarPluginOptions({ options: pluginOptions.toolbar })],
				Boolean(enabledOptionalPlugins.toolbar),
			)
			.add([
				blockMenuPlugin,
				{
					getLinkPath: pluginOptions.blockMenu?.getLinkPath,
					blockLinkHashPrefix: pluginOptions.blockMenu?.blockLinkHashPrefix,
				},
			])
			.add(undoRedoPlugin)
			.add([
				selectionToolbarPlugin,
				selectionToolbarPluginOptions({ options: pluginOptions.selectionToolbar, providers }),
			])

			// ── Content (GFM-safe) ──────────────────────────────────────────
			.add([hyperlinkPlugin, hyperlinkPluginOptions({ options: pluginOptions.hyperlink })])
			.add([
				textFormattingPlugin,
				{
					...textFormattingPluginOptions({ options: pluginOptions.textFormatting }),
					// Underline, subscript and superscript have no GFM equivalent and
					// cannot round-trip through markdown, so hide them from the toolbar.
					disableUnderline: true,
					disableSuperscriptAndSubscript: true,
				},
			])
			.add([blockTypePlugin, blockTypePluginOptions({ options: pluginOptions.blockType })])
			.add(clearMarksOnEmptyDocPlugin)
			.add(widthPlugin)
			.add([
				quickInsertPlugin,
				{
					...quickInsertPluginOptions({ options: pluginOptions.quickInsert }),
					itemFilter: (item) => {
						// Restrict the / menu and element browser to
						// GFM-compatible items before applying any consumer itemFilter.
						if (!isMarkdownCompatibleQuickInsertItem(item)) {
							return false;
						}
						return typeof pluginOptions.quickInsert.quickInsert === 'object'
							? (pluginOptions.quickInsert.quickInsert.itemFilter?.(item) ?? true)
							: true;
					},
				},
			])
			.add([
				placeholderPlugin,
				placeholderPluginOptions({ intl, options: pluginOptions.placeholder }),
			])
			.add(unsupportedContentPlugin)
			.add([
				editorDisabledPlugin,
				editorDisabledPluginOptions({ options: pluginOptions.editorDisabled }),
			])
			.add([submitEditorPlugin, submitEditorPluginOptions({ options: pluginOptions.submitEditor })])
			.add(copyButtonPlugin)
			.maybeAdd(floatingToolbarPlugin, enabledOptionalPlugins.floatingToolbar ?? true)
			.maybeAdd(interactionPlugin, Boolean(enabledOptionalPlugins.interaction))
			.add([selectionPlugin, selectionPluginOptions({ options: pluginOptions.selection })])
			.add([codeBlockPlugin, codeBlockPluginOptions({ providers })])
			.add(ufoPlugin)
			.add(dataConsumerPlugin)
			.add(accessibilityUtilsPlugin)
			.add(contentInsertionPlugin)
			.add(batchAttributeUpdatesPlugin)
			.add(listPlugin)
			.add([
				toolbarListsIndentationPlugin,
				{
					// indentationPlugin is intentionally excluded from markdown mode
					// (indentation has no GFM equivalent), so disable the indent/outdent
					// buttons and only surface the bullet/ordered list buttons.
					showIndentationButtons: false,
					allowHeadingAndParagraphIndentation: false,
				},
			])
			.add(rulePlugin)

			// ── Media (markdown image syntax) ───────────────────────────────
			// gridPlugin is a structural dependency of mediaPlugin even though
			// grid layouts themselves aren't markdown-compatible.
			.add(gridPlugin)
			// breakoutPlugin is included for *schema compatibility only* —
			// stored rich-mode pages may carry a `breakout` mark on code blocks
			// (and other block nodes) which would otherwise cause the collab
			// `Node.fromJSON` path to throw `RangeError: There is no mark type
			// breakout in this schema`. We don't surface the breakout UI in
			// markdown mode (no toolbar button is wired); the mark just sits
			// inert until the user re-saves the page.
			.add([breakoutPlugin, breakoutPluginOptions({ options: { editorAppearance: 'full-page' } })])
			.add([mediaPlugin, mediaPluginOptions({ intl, options: pluginOptions.media, providers })])
			.add(mediaInsertPlugin)
			.maybeAdd(
				[
					aiImageGenerationPlugin,
					aiImageGenerationPluginOptions({ options: pluginOptions.aiImageGeneration }),
				],
				enabledOptionalPlugins.aiImageGeneration,
			)
			// ── Tables, tasks/decisions, annotations ────────────────────────
			.add([tablePlugin, tablePluginOptions({ options: pluginOptions.table })])
			.add([
				tasksAndDecisionsPlugin,
				tasksAndDecisionsPluginOptions({ options: pluginOptions.tasksAndDecisions, providers }),
			])
			.add([
				helpDialogPlugin,
				helpDialogPluginOptions({
					options: {
						imageUploadProviderExists: false,
						aiEnabled: enabledOptionalPlugins.aiExperience,
					},
				}),
			])
			.maybeAdd(
				[
					collabEditPlugin,
					collabEditPluginOptions({ options: pluginOptions.collabEdit, providers }),
				],
				Boolean(pluginOptions.collabEdit.collabEdit),
			)

			// ── Misc UI / utility plugins ───────────────────────────────────
			.add([contextPanelPlugin, contextPanelPluginOptions({ options: pluginOptions.contextPanel })])
			.add([extensionPlugin, extensionPluginOptions({ options: pluginOptions.extension ?? {} })])
			.add(scrollIntoViewPlugin)
			.add([
				insertBlockPlugin,
				{
					...insertBlockPluginOptions({ options: pluginOptions.insertBlock }),
					itemFilter: (item) => {
						const name = item.value.name;
						// Decisions and statuses have no GFM equivalent, so hide them
						// from the pre-'View More' suggestions.
						if (name === 'decision' || name === 'status') {
							return false;
						}
						return pluginOptions.insertBlock?.itemFilter?.(item) ?? true;
					},
				},
			])
			.add([avatarGroupPlugin, avatarGroupPluginOptions({ options: pluginOptions.avatarGroup })])
			.add(fragmentPlugin)
			.add([
				codeBidiWarningPlugin,
				codeBidiWarningPluginOptions({ options: pluginOptions.codeBidiWarning }),
			])

			// ── Referentiality (link-tracking) ──────────────────────────────
			.maybeAdd(
				[
					referentialityPlugin,
					enabledOptionalPlugins.referentiality
						? referentialityPluginOptions({ options: pluginOptions.referentiality })
						: undefined,
				],
				enabledOptionalPlugins.referentiality,
			)

			// ── View mode (markdown / source / preview toggle) ──────────────
			.add([
				editorViewModePlugin,
				editorViewModePluginOptions({ options: pluginOptions.editorViewMode }),
			])
			.add(editorViewModeEffectsPlugin)

			// ── AI ──────────────────────────────────────────────────────────
			// `aiDefinitionsPlugin` depends on `editorViewModePlugin`, so
			// it is added after it.
			.maybeAdd(
				[aiDefinitionsPlugin, aiDefinitionsPluginOptions({ options: pluginOptions.aiDefinitions })],
				enabledOptionalPlugins.aiDefinitions,
			)
			.maybeAdd(
				[aiPlugin, aiPluginOptions({ options: pluginOptions.ai })],
				enabledOptionalPlugins.aiExperience,
			)
			.maybeAdd(
				[
					aiStreamingOrchestratorPlugin,
					aiStreamingOrchestratorPluginOptions({ options: pluginOptions.aiStreamingOrchestrator }),
				],
				enabledOptionalPlugins.aiStreamingOrchestrator,
			)
			.maybeAdd(aiSpeechToTextPlugin, enabledOptionalPlugins.aiSpeechToText)
			.maybeAdd(
				[aiSuggestionsPlugin, aiSuggestionsOptions({ options: pluginOptions.aiSuggestions })],
				enabledOptionalPlugins.aiSuggestions,
			)

			// ── Selection / engagement / metrics / connectivity ─────────────
			.add([
				selectionMarkerPlugin,
				selectionMarkerPluginOptions({ options: pluginOptions.selectionMarker }),
			])
			.add([
				engagementPlatformPlugin,
				engagementPlatformPluginOptions({ options: pluginOptions.engagementPlatform }),
			])
			.maybeAdd(connectivityPlugin, enabledOptionalPlugins.connectivity)
			.maybeAdd(
				[metricsPlugin, metricsPluginOptions({ options: pluginOptions.metrics })],
				enabledOptionalPlugins.metrics,
			)
			.maybeAdd(
				[contentFormatPlugin, contentFormatPluginOptions({ options: pluginOptions.contentFormat })],
				enabledOptionalPlugins.contentFormat,
			)
			.maybeAdd(
				[
					selectionExtensionPlugin,
					selectionExtensionPluginOptions({ options: pluginOptions.selectionExtension }),
				],
				enabledOptionalPlugins.selectionExtension,
			)
			.add(userIntentPlugin)
			.maybeAdd(
				[showDiffPlugin, showDiffPluginOptions({ options: pluginOptions.showDiff })],
				enabledOptionalPlugins.showDiff,
			)
			.maybeAdd(localIdPlugin, enabledOptionalPlugins.localId)

			// ── Annotations (inline comments) ───────────────────────────────
			// annotationPluginOptions returns undefined when no provider is supplied,
			// in which case the plugin is added without options (schema mark still
			// registers, but comment creation UI is not activated — correct behaviour
			// for pages where inline comments are disabled).
			.add([
				annotationPlugin,
				annotationPluginOptions({
					options: pluginOptions.annotation ?? {
						annotationManager: undefined,
						createCommentExperience: undefined,
						selectCommentExperience: undefined,
					},
					providers,
				}),
			])

			// ── Smart Links (inline only) ───────────────────────────────────
			// Markdown mode renders only inline cards: blockCard/embedCard have
			// no markdown surface and stay out of the schema entirely via
			// `onlyInlineCards`. Added after editorViewMode and annotation so
			// its optional dependencies resolve. Skipped when callers don't
			// supply `pluginOptions.card`, since cardPluginOptions needs an
			// editorAppearance and a provider to do anything useful.
			.maybeAdd(
				[
					cardPlugin,
					pluginOptions.card
						? {
								...cardPluginOptions({ options: pluginOptions.card, providers }),
								onlyInlineCards: true,
							}
						: undefined,
				],
				Boolean(pluginOptions.card),
			) as /*
		 * ── Intentionally excluded ────────────────────────────────────────
		 * Adding a plugin to this preset is a deliberate compatibility
		 * statement — if a new plugin lands in `fullPagePreset` it is *not*
		 * automatically picked up here. Keep this list curated.
		 *
		 * Confluence-specific rich-only nodes (no GFM equivalent):
		 *   - panelPlugin
		 *   - expandPlugin
		 *   - layoutPlugin
		 *   - syncedBlockPlugin
		 *   - statusPlugin
		 *   - datePlugin
		 *   - guidelinePlugin          (image sizing guides — no markdown
		 *                              syntax for image dimensions)
		 *   - loomPlugin               (embedded Loom playback nodes)
		 *
		 * Marks with no GFM equivalent:
		 *   - alignmentPlugin
		 *   - textColorPlugin
		 *   - highlightPlugin
		 *   - borderPlugin
		 *   - indentationPlugin
		 *
		 * revisit: planned to add once stable / once their persistence story
		 * supports markdown round-tripping:
		 *   - captionPlugin            (figure captions under media)
		 *   - mentionsPlugin           (@-mentions)
		 *   - emojiPlugin              (emoji nodes)
		 */

		unknown as MarkdownCompatiblePresetBuilder
	);
}

/**
 * Confluence's full Markdown Mode preset, including the source-view plugin.
 *
 * This is the Markdown-compatible WYSIWYG preset plus `markdownModePlugin`.
 * Use {@link markdownCompatiblePreset} when consumers do not need the source
 * editor or its view-toggle UI.
 */
export function markdownPreset(props: MarkdownPresetProps): MarkdownPresetBuilder {
	return markdownCompatiblePreset(props).add([
		markdownModePlugin,
		props.markdownMode,
	]) as unknown as MarkdownPresetBuilder;
}
